import React from "react";
import { cn } from "@/lib/utils";

export function Logo({ className }) {
  return (
    <div className={cn("flex items-center gap-2.5 select-none", className)}>
      <img
        src="/assets/next-time-logo.webp"
        alt="Next Time"
        className="h-8 w-auto object-contain"
        draggable={false}
      />
    </div>
  );
}
